import { z } from "zod";

import { WebhookTranscriptUpdateSchema } from "../types";
import { TranscriptQuestionClassificationSchema } from "./TranscriptQuestionClassification";

export const TranscriptUpdateSchema = WebhookTranscriptUpdateSchema.extend({
  id: z.string(),
  latency: z.number().optional(),
  end_latency: z.number().optional(),
  classification: TranscriptQuestionClassificationSchema.optional(),
});

export type TranscriptUpdate = z.infer<typeof TranscriptUpdateSchema>;
